// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceSubscription {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        this.status = model.status;
        this.seatLimit = model.seatLimit;
        this.seats = model.seats;
        this.fullSeatLimit = model.fullSeatLimit;
        this.fullSeats = model.fullSeats;
        this.product = model.product;
        this.planInterval = model.planInterval;
        this.planPriceId = model.planPriceId;
        this.currentPeriodStart = model.currentPeriodStart
            ? new Date(model.currentPeriodStart)
            : null;
        this.currentPeriodEnd = model.currentPeriodEnd
            ? new Date(model.currentPeriodEnd)
            : null;
        this.stripeCustomerId = (_a = model.stripeCustomerId) !== null && _a !== void 0 ? _a : null;
        this.stripeSubscriptionId = (_b = model.stripeSubscriptionId) !== null && _b !== void 0 ? _b : null;
        // @ts-expect-error TS(2322): Type '{ last4: string | undefined; expiryMonth: st... Remove this comment to see the full error message
        this.card = model.card
            ? {
                last4: model.card.last4,
                expiryMonth: model.card.expiryMonth,
                expiryYear: model.card.expiryYear,
                brand: (_c = model.card.brand) !== null && _c !== void 0 ? _c : null,
            }
            : null;
        this.amount = model.amount;
        this.stripeProductDescription = (_d = model.stripeProductDescription) !== null && _d !== void 0 ? _d : null;
        this.subscriptionStatusUpdatedAt = model.subscriptionStatusUpdatedAt
            ? new Date(model.subscriptionStatusUpdatedAt)
            : null;
        this.legacyVersion = (_e = model.legacyVersion) !== null && _e !== void 0 ? _e : null;
        this.isPricePerCreator = (_f = model.isPricePerCreator) !== null && _f !== void 0 ? _f : false;
        this.stripeProductFeatures = (_g = model.stripeProductFeatures) !== null && _g !== void 0 ? _g : [];
        this.stripeProductAdditionalFeatures =
            (_h = model.stripeProductAdditionalFeatures) !== null && _h !== void 0 ? _h : [];
        this.featuresSummary = (_j = model.featuresSummary) !== null && _j !== void 0 ? _j : {};
        this.creditBalance = (model === null || model === void 0 ? void 0 : model.creditBalance)
            ? {
                free: ((_k = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _k === void 0 ? void 0 : _k.free)
                    ? {
                        credits: Object.assign(Object.assign({}, model.creditBalance.free.credits), { resetAt: model.creditBalance.free.credits.resetAt
                                ? new Date(model.creditBalance.free.credits.resetAt)
                                : null }),
                        spendingLimit: Object.assign(Object.assign({}, model.creditBalance.free.spendingLimit), { resetAt: model.creditBalance.free.spendingLimit.resetAt
                                ? new Date(model.creditBalance.free.spendingLimit.resetAt)
                                : null }),
                    }
                    : null,
                paidTopUp: (_m = (_l = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _l === void 0 ? void 0 : _l.paidTopUp) !== null && _m !== void 0 ? _m : null,
                paidRecurring: ((_o = model === null || model === void 0 ? void 0 : model.creditBalance) === null || _o === void 0 ? void 0 : _o.paidRecurring)
                    ? Object.assign(Object.assign({}, model.creditBalance.paidRecurring), { resetAt: model.creditBalance.paidRecurring.resetAt
                            ? new Date(model.creditBalance.paidRecurring.resetAt)
                            : null }) : null,
            }
            : null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toRemote() {
        var _a, _b, _c, _d;
        // Implement according to your needs
        return {
            status: this.status,
            seatLimit: this.seatLimit,
            seats: this.seats,
            product: this.product,
            planInterval: this.planInterval,
            planPriceId: this.planPriceId,
            stripeCustomerId: (_a = this.stripeCustomerId) !== null && _a !== void 0 ? _a : undefined,
            stripeSubscriptionId: (_b = this.stripeSubscriptionId) !== null && _b !== void 0 ? _b : undefined,
            // @ts-expect-error TS(2322): Type '{ last4: string | null; expiryMonth: string ... Remove this comment to see the full error message
            card: this.card,
            currentPeriodStart: this.currentPeriodStart
                ? this.currentPeriodStart.toISOString()
                : undefined,
            currentPeriodEnd: this.currentPeriodEnd
                ? this.currentPeriodEnd.toISOString()
                : undefined,
            amount: this.amount,
            stripeProductDescription: (_c = this.stripeProductDescription) !== null && _c !== void 0 ? _c : undefined,
            subscriptionStatusUpdatedAt: 
            // @ts-expect-error TS(2531): Object is possibly 'null'.
            this.subscriptionStatusUpdatedAt.toISOString(),
            // @ts-expect-error TS(2322): Type 'number | null' is not assignable to type 'nu... Remove this comment to see the full error message
            legacyVersion: this.legacyVersion,
            isPricePerCreator: this.isPricePerCreator,
            stripeProductFeatures: this.stripeProductFeatures,
            stripeProductAdditionalFeatures: this.stripeProductAdditionalFeatures,
            featuresSummary: this
                .featuresSummary,
            creditBalance: this.creditBalance
                ? {
                    free: this.creditBalance.free
                        ? {
                            credits: Object.assign(Object.assign({}, this.creditBalance.free.credits), { resetAt: this.creditBalance.free.credits.resetAt
                                    ? this.creditBalance.free.credits.resetAt.toISOString()
                                    : undefined }),
                            spendingLimit: Object.assign(Object.assign({}, this.creditBalance.free.spendingLimit), { resetAt: this.creditBalance.free.spendingLimit.resetAt
                                    ? this.creditBalance.free.spendingLimit.resetAt.toISOString()
                                    : undefined }),
                        }
                        : undefined,
                    paidTopUp: (_d = this.creditBalance.paidTopUp) !== null && _d !== void 0 ? _d : undefined,
                    paidRecurring: this.creditBalance.paidRecurring
                        ? Object.assign(Object.assign({}, this.creditBalance.paidRecurring), { resetAt: this.creditBalance.paidRecurring.resetAt
                                ? this.creditBalance.paidRecurring.resetAt.toISOString()
                                : undefined }) : undefined,
                }
                : undefined,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceSubscription(model);
    }
}
